/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addUser = /* GraphQL */ `
  mutation AddUser($input: UserInput!) {
    addUser(input: $input) {
      cognito_id
      email
      updated
      __typename
    }
  }
`;

export const putFeedback = /* GraphQL */ `
mutation PutFeedback($input: FeedbackInput!) {
  putFeedback(input: $input) {
    success
    message
  }
}
`;

export const updateUser = /* GraphQL */ `
  mutation updateUser($email: String!, $input: UpdateUserInput!) {
    updateUser(email: $email, input: $input) {
      gtag
    }
  }
`;

export const refreshAPIKey = /* GraphQL */ `
  mutation RefreshAPIKey($email: ID!) {
    refreshAPIKey(email: $email)
  }
`;

export const submitPropertyTransaction = /* GraphQL */ `
  mutation SubmitPropertyTransaction($input: PropertyTransactionInput!) {
    submitPropertyTransaction(input: $input) {
      success
      message
      submission_id
    }
  }
`;

export const voteOnSubmission = /* GraphQL */ `
  mutation VoteOnSubmission($input: VoteInput!) {
    voteOnSubmission(input: $input) {
      success
      message
      upvotes
      downvotes
      score
    }
  }
`;

export const lookupListing = /* GraphQL */ `
  mutation LookupListing($input: ListingLookupInput!) {
    lookupListing(input: $input) {
      success
      message
      paywalled
      listing {
        listing_id
        source
        postcode_area
        property_type
        total_floor_area
        tenure
        new_build
      }
      valuation {
        mean
        median
        low
        high
        estimates
      }
      comparables {
        address
        post_code
        price
        date
        type
        distance_metres
      }
    }
  }
`;